import angular from 'angular';

import Organizations from './organizations.component';

import './organizations.component.scss';

export default angular.module('petrocloud.organizations', [])
  .component(Organizations.name, Organizations)
  .name;
